import axios from "axios";

const BASE_URL = import.meta.env.VITE_MERCHANT_SERVICE_BASE_URL;

export function postPaymentLinkReceipt(linkId: string, recipientEmail: string) {
  return axios.post(`${BASE_URL}/v1/payment-links/${linkId}/receipt`, { recipientEmail });
}
